import React, { useState, useEffect } from 'react';
import '../index.css';
import { searchRecordInAirTable, updateRecordInAirTable, createRecordInAirTable, savingFunc } from '../functions.js/airTableDB';
import WorkflowBuilder from '../components/workflowBuilder';
import './editTable.css';

const GruppenBuilder = () => {
  const [gruppenVorlagen, setGruppenVorlagen] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchGroups = async () => {
      const groups = await searchRecordInAirTable("groups");
      console.log("[Page-Groups]: ", groups);

      // Sortiere alphabetisch Gruppen nach groups[x].fields.f_name
      if (groups) {
        groups.sort((a, b) => a.fields.f_name.localeCompare(b.fields.f_name));
      }

      setGruppenVorlagen(groups || []);
    };

    const fetchData = async () => {
      await Promise.all([fetchGroups()]);
      setIsLoading(false);
    };
    fetchData();
  }, []);

  if (isLoading) {
    return <p>Lade Daten...</p>;
  }

  return (
    <>
      <GroupTable groups={gruppenVorlagen} setGroups={setGruppenVorlagen} />
    </>
  );
};

const GroupTable = ({ groups, setGroups }) => {
    const [editedGroups, setEditedGroups] = useState({});
    const [originalGroups, setOriginalGroups] = useState({});
    const [editingGroup, setEditingGroup] = useState(null);
    const [newGroup, setNewGroup] = useState(null);
  
    // Neue Validierungsfunktion
    const isValidGroupName = (name) => {
      if (!name || name.trim() === '') return false;
      // Erlaubt nur Buchstaben, Zahlen und Leerzeichen
      return /^[a-zA-Z0-9\s]+$/.test(name);
    };
  
    useEffect(() => {
      const initialEdits = {};
      const originalData = {};
      groups.forEach(group => {
        initialEdits[group.id] = { name: group.fields?.name || '' };
        originalData[group.id] = group.fields?.name || '';
      });
      setEditedGroups(initialEdits);
      setOriginalGroups(originalData);
    }, [groups]);
  
    const handleInputChange = (groupId, value) => {
      // Nur erlaubte Zeichen akzeptieren
      if (value === '' || /^[a-zA-Z0-9\s]*$/.test(value)) {
        setEditedGroups(prev => ({
          ...prev,
          [groupId]: { name: value }
        }));
      }
    };
  
    const hasChanges = (groupId) => {
      const newName = editedGroups[groupId]?.name || '';
      return newName !== originalGroups[groupId] && isValidGroupName(newName);
    };
  
    const handleSave = async (groupId) => {
      if (!hasChanges(groupId)) return; // Speichern nur, wenn sich was geändert hat
      const updatedData = { name: editedGroups[groupId].name };
      await updateRecordInAirTable(groupId, updatedData, 'groups');
      setGroups(prev =>
        prev.map(group =>
          group.id === groupId ? { ...group, fields: { ...group.fields, ...updatedData } } : group
        )
      );
      setOriginalGroups(prev => ({
        ...prev,
        [groupId]: updatedData.name
      }));
      alert('Gruppe erfolgreich gespeichert!');
    };
  
    const handleDiscard = (groupId) => {
      setEditedGroups(prev => ({
        ...prev,
        [groupId]: { name: originalGroups[groupId] }
      }));
    };
  
    const toggleGroupBuilder = (groupId) => {
      setEditingGroup(editingGroup === groupId ? null : groupId);
    };
  
    const closeChartFunc = () => {
      setEditingGroup(null);
    };
  
    const handleNewSave = async () => {
      if (!newGroup?.name.trim() || !isValidGroupName(newGroup.name)) return;
      const newData = {
        name: newGroup.name,
        vorlageJSON: JSON.stringify({
          "children_connections": [],
          "children": []
        }),
        isTemplate: true
      };
      const result = await createRecordInAirTable(newData, 'groups');
  
      if (result) {
        setGroups(prev => [...prev, result]);
        setNewGroup(null);
        alert('Neue Gruppe erfolgreich erstellt!');
      }
    };
  
    const handleNewCancel = () => {
      setNewGroup(null);
    };
  
    return (
      <div className="group-table">
        <h2>Gruppen Vorlagen</h2>
        <div className="group-header">
          <span>Name</span>
          <span>Aktionen</span>
        </div>
  
        {groups.map(group => (
          <React.Fragment key={group.id}>
            <div className={`group-row ${editingGroup === group.id ? 'editing' : ''}`}>
              <input
                type="text"
                value={editedGroups[group.id]?.name || ''}
                onChange={(e) => handleInputChange(group.id, e.target.value)}
                disabled={editingGroup === group.id}
              />
              <div className="actions">
                {editingGroup !== group.id && (
                  <>
                    {hasChanges(group.id) && (
                      <>
                        <button className="btn save" onClick={() => handleSave(group.id)}>💾</button>
                        <button className="btn discard" onClick={() => handleDiscard(group.id)}>✖</button>
                      </>
                    )}
                    <button className="btn edit" onClick={() => toggleGroupBuilder(group.id)}>👀</button>
                  </>
                )}
              </div>
            </div>
  
            {editingGroup === group.id && (
              <div className="workflow-builder">
                <WorkflowBuilder
                  isTemplateEditing={true}
                  modus="editGroup"
                  templteRecID={group.id}
                  savingFunc={savingFunc}
                  closeChartFun={closeChartFunc}
                />
              </div>
            )}
          </React.Fragment>
        ))}
  
        {newGroup && (
          <div className="group-row new">
            <input
              type="text"
              placeholder="Neue Gruppe..."
              value={newGroup.name}
              onChange={(e) => {
                const value = e.target.value;
                if (value === '' || /^[a-zA-Z0-9\s]*$/.test(value)) {
                  setNewGroup({ ...newGroup, name: value });
                }
              }}
            />
            <div className="actions">
              {newGroup?.name.trim() && isValidGroupName(newGroup.name) && (
                <>
                  <button className="btn save" onClick={handleNewSave}>💾</button>
                  <button className="btn discard" onClick={handleNewCancel}>✖</button>
                </>
              )}
            </div>
          </div>
        )}
  
        {!newGroup && (
          <button className="btn new-group" onClick={() => setNewGroup({ name: '' })}>
            + Neue Gruppe
          </button>
        )}
      </div>
    );
  };

export default GruppenBuilder;
